import type { InputProps } from '../types';

import { Input } from './input';

export type Props = InputProps<string>;

export const HiddenField = ({ onChange, ...props }: Props) => (
  <Input
    {...props}
    type="hidden"
    onChange={(event) => onChange?.(event.target.value)}
  />
);
